import { useCallback, useEffect, useMemo, useState } from 'react';
import { Edit2, Trash } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import PaginationClassic from '../../components/infrastructure/pagination/PaginationClassic';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import {
    deleteEmployee,
    fetchEmployees,
    getEmployees,
} from '../../app/reducers/Users/EmployeeSlice';
import { useNavigate } from 'react-router-dom';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import ChangePasswordModal from './ChangePasswordModal';
import { IoKeyOutline } from "react-icons/io5";
import { authAxiosInstance } from '../../utils/axiosConfig';
import QueryString from 'qs';
import { fetchDispatchLocations, getDispatchLocation } from '../../app/reducers/DispatchLocation/dispatchLocationSlice';
const ViewEmployees = () => {
    const { employees, loading } = useSelector(getEmployees);
    const { dispatchLocation } = useSelector(getDispatchLocation);
    console.log("dispatchLocation", dispatchLocation)


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const debouncedSearch = useCallback(
        _.debounce((search) => {
            console.log('searching');
            dispatch(fetchProducts({ search: search, populate: true }));
        }, 300),
        []
    );
    const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
    const [empData, setEmpData] = useState(null);
    const [page, setPage] = useState(1);

    const cols = [
        {
            Header: 'Name',
            Cell: ({ row }) => {
                return (
                    <span>
                        {row.original.firstName} {row.original.lastName}
                    </span>
                );
            },
        },

        {
            Header: 'Phone',
            accessor: 'username',
        },
        {
            Header: 'Role',
            accessor: 'role',
        }, {
            Header: 'Location',
            Cell: ({ row }) => {
                console.log("row", row)
                const location = dispatchLocation?.docs?.find(
                    (loc) =>
                        String(loc?._id) === String(row?.original?.location)
                );
                console.log(location)
                return (
                    <span>
                        {location?.name || '-'}
                    </span>
                );
            },

        },
        {
            Header: 'Action',
            Cell: ({ row }) => {
                return (
                    <div className="flex gap-3 items-center">
                        <div className={"py-1"} title={"Change Password"}>
                            <IoKeyOutline
                                size={20}
                                color='green'
                                className='cursor-pointer'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setEmpData(row?.original?._id)
                                    setOpenChangePasswordModal(true);
                                }}
                            />
                        </div>
                        <Edit2
                            size={20}
                            className='cursor-pointer'
                            color='blue'
                            onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/users/editEmployee/${row.original._id}`);
                            }}
                        />
                        <Trash
                            size={20}
                            className='cursor-pointer'
                            onClick={async () => {
                                await dispatch(
                                    deleteEmployee({ id: row.original._id })
                                );
                                dispatch(fetchEmployees());
                            }}
                            color="red"
                        />
                    </div>
                );
            },
        },
    ];
    const data = useMemo(
        () => (employees?.docs ? employees.docs : []),
        [employees]
    );
    useEffect(() => {
        dispatch(fetchEmployees());
        dispatch(fetchDispatchLocations({ populate: true }));
    }, [page]);
    return (
        <PageWithCard heading='View Employees'>
            <ChangePasswordModal
                openChangePasswordModal={openChangePasswordModal}
                setOpenChangePasswordModal={setOpenChangePasswordModal}
                userId={empData}
            />
            <div className="p-4">
                <TableWithHeadingAndGlobalSearch
                    loading={loading}
                    data={data}
                    searchFunction={debouncedSearch}
                    columns={cols}
                />
                <PaginationClassic
                    setPage={setPage}
                    paginationDetails={employees}
                />
            </div>
        </PageWithCard>
    );
};

export default ViewEmployees;
